// Feb-2026 — Pflichtfeld-Validierung für CreateListingPage, ausgelagert aus
// CreateListingPage.jsx. Reine Funktion: berechnet die Liste der noch fehlenden
// Pflichtfelder (Banner + rote Hervorhebungen + Popup beim Speichern).
export function computeMissingRequired(form, { isMotoCat, isDealerCat, specialMode }) {
    const out = [];
    if (!form.title) out.push({ key: "title", label: "Titel", selector: '[data-testid="form-title"]' });
    if (!form.brand) out.push({ key: "brand", label: "Marke", selector: '[data-testid="form-brand"]' });
    if (!form.model) out.push({ key: "model", label: "Modell", selector: '[data-testid="form-model"]' });
    // Jun-2026 (User-Wunsch) — Spezial-Modus (Auktion/Sharing): nur die Eckdaten
    // (Titel, Marke, Modell) + mind. 1 Bild sind Pflicht. Alle übrigen Fahrzeug-
    // Pflichtfelder entfallen, da das Formular ausgeblendet ist.
    if (specialMode) {
        if (!Array.isArray(form.images) || form.images.length === 0) out.push({ key: "images", label: "Bilder (≥ 1)", selector: '[data-testid="image-upload-section"]' });
        return out;
    }
    if (isMotoCat ? !form.vehicle_type : !form.bike_type) out.push({ key: isMotoCat ? "vehicle_type" : "bike_type", label: isMotoCat ? "Fahrzeugtyp" : "Fahrradtyp", selector: isMotoCat ? '[data-testid="form-vehicle-type"]' : '[data-testid="form-bike-type"]' });
    if (!form.condition) out.push({ key: "condition", label: "Zustand", selector: '[data-testid="listing-condition"]' });
    if (!["auction", "pawn"].includes(form.sale_type) && !form.price) out.push({ key: "price", label: "Preis B2C", selector: '[data-testid="form-price"]' });
    if (!form.first_registration_date && !form.year) out.push({ key: "first_registration_date", label: "Erstzulassung", selector: '[data-testid="form-erstzulassung"], [data-testid="form-first-registration"], [data-testid="form-year"]' });
    if (form.previous_owners === "" || form.previous_owners == null) out.push({ key: "previous_owners", label: "Anzahl Vorbesitzer", selector: '[data-testid="extra-previous-owners"]' });
    if (form.mileage === "" || form.mileage == null) out.push({ key: "mileage", label: "Kilometerstand", selector: '[data-testid="form-mileage"]' });
    if (!form.color_base) out.push({ key: "color_base", label: "Farbbasis", selector: '[data-testid="listing-color-base"]' });
    // Mai-2026 Iteration 7 (User-Wunsch 21 May): B2B-Preis und Vermittlungsprovision sind Pflichtfelder
    // (nur für Händler/Dealer, da nur diese die Felder sehen)
    if (isDealerCat) {
        if (form.price_b2b === "" || form.price_b2b == null) out.push({ key: "price_b2b", label: "Preis B2B (Gewerblich)", selector: '[data-testid="form-price-b2b"]' });
        if (form.referral_commission_eur === "" || form.referral_commission_eur == null) out.push({ key: "referral_commission_eur", label: "Vermittlungsprovision", selector: '[data-testid="form-referral-commission"]' });
    }
    // Mai-2026 — Motor-Felder als Pflicht (nur für Motorräder/Roller, nicht für Fahrräder)
    if (isMotoCat) {
        if (form.displacement === "" || form.displacement == null) out.push({ key: "displacement", label: "Hubraum (ccm)", selector: '[data-testid="form-displacement"]' });
        if (form.power_kw === "" || form.power_kw == null) out.push({ key: "power_kw", label: "Leistung (kW)", selector: '[data-testid="listing-power-kw"]' });
        // Feb-2026 (Bug-Fix): „Antrieb" (drive_type) war in der submit()-Validierung
        // Pflicht, fehlte aber in der Live-Liste → Dialog zeigte es nicht an
        // und der Inserent konnte das fehlende Feld nicht finden.
        if (!form.drive_type) out.push({ key: "drive_type", label: "Antrieb", selector: '[data-testid="listing-drive-type"]' });
        if (!form.fuel) out.push({ key: "fuel", label: "Kraftstoff", selector: '[data-testid="listing-fuel"]' });
        if (!form.transmission) out.push({ key: "transmission", label: "Getriebe", selector: '[data-testid="listing-transmission"]' });
    }
    // Feb-2026 (Bug-Fix): Bilder werden im Form-State unter `form.images`
    // gespeichert (siehe ImageGridSection.jsx), NICHT unter `image_urls`.
    // Vorheriger Check verglich gegen falsches Property → meldete „Bilder
    // fehlen" obwohl der Inserent Fotos hochgeladen hatte.
    if (!Array.isArray(form.images) || form.images.length === 0) out.push({ key: "images", label: "Bilder (≥ 1)", selector: '[data-testid="image-upload-section"]' });
    return out;
}

// Feb-2026 — springt zum ersten fehlenden Pflichtfeld. Klappt zuvor alle
// eingeklappten Sections auf (deren children sonst nicht im DOM sind),
// scrollt das Feld zentriert ein und hebt es kurz rot hervor.
export function jumpToMissing(selector) {
    const expandAll = () => {
        const collapsedBtns = Array.from(document.querySelectorAll('[aria-expanded="false"]'))
            .filter((btn) => {
                // Nur Buttons innerhalb der CreateListing-Sektionen,
                // keine Dropdowns/Menüs außerhalb der Form.
                const tid = btn.getAttribute("data-testid") || "";
                return /-section-btn$|-toggle$|description-section-btn$/.test(tid)
                    || btn.closest('[data-testid$="-section"]')
                    || btn.closest('[data-testid$="-toggle"]');
            });
        collapsedBtns.forEach((btn) => {
            try { btn.click(); } catch { /* ignore */ }
        });
    };
    const tryJump = (attempt = 0) => {
        const el = document.querySelector(selector);
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
            el.classList.add("ring-2", "ring-red-400", "ring-offset-2");
            setTimeout(() => el.classList.remove("ring-2", "ring-red-400", "ring-offset-2"), 1800);
            try { el.focus({ preventScroll: true }); } catch { /* ignore */ }
            return;
        }
        if (attempt === 0) {
            expandAll();
            setTimeout(() => tryJump(1), 200);
        }
    };
    tryJump();
}
